import React, { useState, useEffect } from "react";
import Select from "react-select";
import axios from "axios";

const SelectCorporate = ({
  onSelectCompany,
  selectedValue,
  corporateId = null,
  isDisabled = false,
}) => {
  const [corporateCompanies, setCorporateCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchCorporateCompanies();
  }, [corporateId]);

  const fetchCorporateCompanies = async () => {
    setLoading(true);
    setError(null);
    try {
      const url = `${apiUrl}/corporate/list${corporateId ? `?corporateid=${corporateId}` : ""}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.data && Array.isArray(response.data.companies)) {
        const formattedOptions = response.data.companies
          .filter((company) => company.status === true) // Filter companies with status true
          .map((company) => ({
            value: company.id,
            label: company.name,
            companyDetails: company,
          }));
        setCorporateCompanies(formattedOptions);
      } else {
        throw new Error("Invalid response format: 'companies' array not found");
      }
    } catch (error) {
      console.error("Error fetching corporate companies:", error);
      setError("Failed to load corporate companies. Please try again.");
      setCorporateCompanies([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Select
      options={corporateCompanies}
      onChange={onSelectCompany}
      value={corporateCompanies.find((option) => option.value === selectedValue) || null}
      placeholder="Select Corporate Company"
      isLoading={loading}
      isDisabled={isDisabled || loading || !!error}
      noOptionsMessage={() =>
        error ? error : loading ? "Loading..." : "No companies available"
      }
      isClearable
    />
  );
};

export default SelectCorporate;